<button
  mat-button
  [color]="settings.buttonColor"
  [class]="settings.buttonClass"
  [class.inProgress]="settings.inProgress"
  [class.mat-raised-button]="settings.type === 'raised'"
  [class.mat-stroked-button]="settings.type === 'stroked'"
  [class.mat-flat-button]="settings.type === 'flat'"
  [class.full-width]="settings.fullWidth"
  [disabled]="settings.disabled"
  [style.min-height.px]="settings.minHeight">
  @if (settings.img && !settings.inProgress) {
    <img [src]="settings.img" alt="" />
  }
  <span class="btn-label">
    <span class="button-text" [class.inProgress]="settings.inProgress">
      {{ settings.text }}
    </span>
    @if (settings.icon) {
      <mat-icon class="icon">{{ settings.icon }}</mat-icon>
    }
  </span>

  <mat-spinner
    class="spinner"
    [diameter]="settings.spinnerSize"
    [color]="settings.spinnerColor"
    [mode]="settings.mode"
    [class.inProgress]="settings.inProgress"></mat-spinner>
</button>
